import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import io from 'socket.io-client';

import RbSerialConnectionModalComponent from '../components/rb-serial-connection-modal/rb-serial-connection-modal.jsx';

import {closeSerialConnectionModal} from '../reducers/modals';
import {updateStatus, updateVersion} from '../reducers/connection';
import {config} from '../config';

class RbSerialConnectionModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel',
            'handleConnect',
            'handleChange'
        ]);
        this.socket = io(config.socketUrl);
        this.state = {
            selectValue: '',
            ports: []
        };
    }

    componentDidMount () {
        this.socket.on('ports', ports => {
            if (ports.length) {
                this.setState({
                    selectValue: ports[0].comName,
                    ports
                });
            }
        });
    }

    handleCancel (e) {
        e.stopPropagation();
        this.props.onClose();
    }

    /**
     * 连接串口
     */
    handleConnect () {
        const {selectValue} = this.state;
        const that = this;
        this.socket.emit('serialConnect', selectValue, status => {
            if (status) {
                setTimeout(() => {
                    that.socket.emit('ferret', 'getVersion', version => {
                        if (version.startsWith('1.') || version.startsWith('2.')) {
                            that.props.onUpdateVersion(version);
                        }
                    });
                }, 5000);
                this.props.onUpdateStatus(true);
                this.props.onClose();
            }
        });
    }

    handleChange (e) {
        this.setState({
            selectValue: e.target.value
        });
    }
    
    render () {
        return (
            <RbSerialConnectionModalComponent
                ports={this.state.ports}
                selectValue={this.state.selectValue}
                onCancel={this.handleCancel}
                onChange={this.handleChange}
                onConnect={this.handleConnect}
            />
        );
    }
}

RbSerialConnectionModal.propTypes = {
    onClose: PropTypes.func,
    onUpdateStatus: PropTypes.func
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeSerialConnectionModal());
    },
    onUpdateStatus: status => {
        dispatch(updateStatus(status));
    },
    onUpdateVersion: status => {
        dispatch(updateVersion(status));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RbSerialConnectionModal);
